import { createSlice } from "@reduxjs/toolkit";

const initialAuditLogViewState = { data: {}, isOpen: false }

const auditLogViewSlice = createSlice({
    name: 'audit_log_view',
    initialState: initialAuditLogViewState,
    reducers: {
        openModal(state, action) {
            state.data = action.payload
            state.isOpen = true
        },
        closeModal(state, action) {
            state.data = {}
            state.isOpen = false
        }
    }
})

export const auditLogViewActions = auditLogViewSlice.actions;
export default auditLogViewSlice